<template>
  <div id="app">
    <div class="tower_wyh_hy">
      <span>您好，欢迎来到四川五月花技师学院官方网站！</span>
    </div>
    <!-- <a href="/ztxm?ztname=kjx">会计专业</a>
    <a href="/ztxm?ztname=dzsw">电子商务</a>-->
    <div class="header">
      <div class="fl">
        <div class="logo clearfix">
          <router-link to="/">
            <img src="../src/assets/img/logo.png" />
          </router-link>
          <p>
            <b>感恩 阳光 严谨 责任</b>
            <span>{{ qyList.Alias }}</span>
          </p>
        </div>
        <div class="rxdh">
          <span>报名热线：</span>
          <i>{{ bmList.Phone }}</i>
        </div>
      </div>
      <div class="fr">
        <div class="navBtn">
          <span class="icon1"></span>
          <span class="icon2"></span>
          <span class="icon3"></span>
        </div>
        <div class="nav">
          <ul>
            <li>
              <router-link to="/">首页</router-link>
            </li>
            <li v-for="(item, index) in navList" :key="index">
              <template v-if="item.Clist.length == 0">
                <hrefformat
                  :url="item.Url"
                  :param="{ cid: item.ID }"
                  :content="item.Name"
                ></hrefformat>
              </template>
              <template v-else
                ><a>{{ item.Name }}</a></template
              >
              <dl v-if="item.Clist.length > 0">
                <template v-if="item.ID != api.zysz">
                  <dd v-for="(j, index) in item.Clist" :key="index">
                    <!-- <hrefformat
                      :url="j.Url"
                      :param="{ cid: j.ID }"
                      :content="j.Name"
                    ></hrefformat> -->
                    <template v-if="j.Clist.length == 0">
                      <hrefformat
                        :url="j.Url"
                        :param="{ cid: j.ID }"
                        :content="j.Name"
                      ></hrefformat>
                    </template>
                    <template v-else
                      ><a>{{ j.Name }}</a></template
                    >
                    <dl v-if="j.Clist.length > 0">
                      <template v-if="j.ID != api.zysz">
                        <dd v-for="(k, index) in j.Clist" :key="index">
                          <hrefformat
                            :url="k.Url"
                            :param="{ cid: k.ID }"
                            :content="k.Name"
                          ></hrefformat>
                        </dd>
                      </template>
                    </dl>
                  </dd>
                </template>
              </dl>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <router-view :key="$route.fullPath" />
    <div class="footer">
      <div class="fl">
        <router-link to="/">
          <img src="../src/assets/img/footerLogo.png" alt />
        </router-link>
        <p>
          <span>学院地址：成都市郫都区团结镇学院街210号</span>
          <span>邮编：611745</span>
        </p>
        <p>
          <span>报名咨询热线：{{ bmList.Phone }}</span>
        </p>
        <p>
          <span>©四川五月花技师学院</span>
        </p>
        <p>
          <span>All RightsReserved</span>
          <a href="http://beian.miit.gov.cn/" target="_block"
            >蜀ICP备13002319号-1</a
          >
        </p>
      </div>
      <div class="fr">
        <dl>
          <dd>
            <img src="./assets/img/yxt_ewm.jpg" alt />
            <span>关注院校通</span>
          </dd>
          <dd>
            <img src="./assets/img/wx_ewm.jpg" alt />
            <span>关注微信</span>
          </dd>
          <dd>
            <img src="./assets/img/wb_ewm.jpg" alt />
            <span>关注微博</span>
          </dd>
        </dl>
      </div>
      <div class="clearfix"></div>
      <p style="text-align: justify">
        <span style="font-size: 0.18rem; line-height: 1.5"
          >四川五月花技师学院专注职业教育20余年，拥有9大升学优势，初中起点，零门槛入学，升学无忧，初中毕业也能读大学！
          计算机、汽修、烹饪、电竞、会计等多个热门专业任你选择，培养各类高素质技术人才。知识创造财富，技能改变认识，中高职衔接教育，高端定向就业。免费咨询热线：028-66666665</span
        >
      </p>
    </div>
    <div id="bottomFC">
      <a class="btn1" :href="bdsq">
        <span>预约参观</span>
      </a>
      <a class="btn2" :href="bdsq">
        <span>报名咨询</span>
      </a>
      <a class="btn3" :href="'tel:' + bmList.Phone">
        <span>助学政策咨询</span>
      </a>
    </div>
    <!-- {{ store.state.showAddStudent}} -->
    <div id="zxbm" v-if="isShow">
      <div class="zxbmBox">
        <div
          class="close-btn"
          @click="() => this.$store.dispatch('hideAddStudent')"
        ></div>
        <div class="fl">
          <h3 class="imgBox">
            <img src="./assets/img/zxbm_title.jpg" alt />
          </h3>
          <dl class="clearfix">
            <dd>
              <label class="mustInput">姓名</label>
              <input type="text" value v-model="zxbmObj.name" />
            </dd>
            <dd>
              <label class="mustInput">电话</label>
              <input type="text" value v-model="zxbmObj.phone" />
            </dd>
            <dd>
              <label>专业</label>
              <div class="select">
                <h4 @click="selectActive = !selectActive">
                  {{ zxbmObj.project }}
                </h4>
                <ul :class="{ selectActive: selectActive }">
                  <li
                    v-for="(item, index) in zylist"
                    :key="index"
                    @click="getRadioVal(item.Title)"
                  >
                    {{ item.Title }}
                  </li>
                </ul>
              </div>
            </dd>
            <dd>
              <label>QQ</label>
              <input type="text" value v-model="zxbmObj.QQ" />
            </dd>
            <dd>
              <label>其他</label>
              <input type="text" value v-model="zxbmObj.other" />
            </dd>
          </dl>
          <div class="addUser" @click="addUserFun">提交</div>
        </div>
      </div>
    </div>
    <div id="loading" :class="{ on: loadingActive }">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
    </div>
    <div id="T_imgShow" v-show="T_imgShowActive">
      <img :src="T_imgShowUrl" alt="" />
      <div class="close"></div>
    </div>
  </div>
</template>

<script>
import "../src/assets/css/spinkit.min.css";
export default {
  name: "App",
  data() {
    return {
      bmList: [],
      qyList: [],
      zylist: [],
      navList: [],
      zxbmObj: {
        name: "",
        phone: "",
        QQ: "",
        other: "",
        project: ""
      },
      selectActive: false,
      loadingActive: false,
      T_imgShowActive: false,
      T_imgShowUrl: ""
    };
  },
  mounted() {
    var that = this;
    this.bmList = this.Base.GetDepartmentByDid();
    this.qyList = this.Base.GetOrganInfoByOid();
    // this.navList = this.Navformat(this.Base.GetNavColumnsByDid());
    var navData = this.Base.GetNavColumnsByDid();
    function NavColumnsFormart(arr, type, list) {
      for (const iterator of arr) {
        if (iterator.FID == type) {
          iterator.Clist = [];
          list.push(iterator);
          NavColumnsFormart(navData, iterator.ID, iterator.Clist);
        }
      }
    }
    NavColumnsFormart(navData, 0, this.navList);
    // console.log(this.navList);

    // 导航栏显示隐藏
    $(".header .navBtn").click(function() {
      $(".header .nav")
        .stop()
        .slideToggle();
    });
    $(".header .nav").on("click", "ul li", function() {
      $(".header .nav ul li>dl>dd").removeClass("on");
      $(this)
        .siblings()
        .removeClass("on")
        .find(">dl")
        .stop()
        .slideUp();
      $(this)
        .addClass("on")
        .find(">dl")
        .stop()
        .slideToggle();
    });
    $(".header .nav").on("click", "ul li>dl>dd", function() {
      // $(this).siblings().removeClass("on").find(">dl").stop().slideUp();
      $(this)
        .addClass("on")
        .siblings()
        .removeClass("on");
      return false;
    });
    $("#app").on("click", ".T_imgItem", function() {
      that.T_imgShowUrl = "";
      console.log($(this).attr("src"));
      that.T_imgShowActive = true;
      that.T_imgShowUrl = $(this).attr("src");
    });
    $("#app").on("click", "#T_imgShow .close", function() {
      that.T_imgShowActive = false;
      that.T_imgShowUrl = "";
    });

    window.onload = function() {
      // console.log("1111");
      that.loadingActive = true;
    };
    setTimeout(() => {
      console.log("强制关闭loading");
      that.loadingActive = true;
    }, 5000);
  },
  created() {
    var that = this;
  },
  methods: {
    Navformat: function(data) {
      var that = this;
      var obj = data;
      // console.log(obj);
      var temp = [];
      for (var i = 0; i < obj.length; i++) {
        if (obj[i].FID == "0") {
          var main = obj[i];
          main.Clist = [];
          for (var j = 0; j < obj.length; j++) {
            if (obj[j].FID == main.ID) {
              main.Clist.push(obj[j]);
            }
          }
          temp.push(main);
        }
      }
      for (var i = 0; i < temp.length; i++) {
        if (temp[i].ID == that.api.zysz) {
          var zyList = that.Base.GetNewsInfoByCid(
            "",
            that.api.zysz,
            "",
            "",
            "",
            1,
            "",
            30
          ).row;
          that.zylist = zyList;
          temp[i].Clist = zyList;
          // console.log(that.zylist )
        }
      }
      // console.log(temp);
      return temp;
    },
    closeLoading: function() {
      var that = this;
      that.loadingActive = true;
    },
    openzxbm: function() {
      this.$store.dispatch("showAddStudent");
    },
    getRadioVal: function(name) {
      this.zxbmObj.project = name;
      this.selectActive = false;
    },
    addUserFun: function() {
      var that = this;
      var dataTemp = that.zxbmObj;
      var Senddata = {
        Name: "",
        Email: "",
        Mobile: "",
        Title: "",
        Info: "",
        ColumnID: that.api.zxbm
      };
      if (that.Curren.isEmpty(dataTemp.name)) {
        alert("请输入姓名");
        return false;
      }
      // console.log(dataTemp.QQ == '')
      if (dataTemp.phone == "" && dataTemp.QQ == "") {
        // console.log(that.Curren.isEmpty(dataTemp.QQ))
        alert("请输入电话号码或QQ号码");
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(dataTemp.phone)) {
        alert("手机号码有误，请重填");
        return false;
      }
      if (that.Curren.isEmpty(dataTemp.project)) {
        alert("请选择专业");
        return false;
      }
      Senddata.Name = dataTemp.name;
      Senddata.Email = dataTemp.QQ;
      Senddata.Mobile = dataTemp.phone;
      Senddata.Title = dataTemp.project;
      Senddata.Info = "其他信息：" + dataTemp.other;
      console.log(Senddata);
      var fhz = that.Base.sendMail(Senddata);
      alert(fhz.message);
    }
  },
  computed: {
    isShow() {
      return this.$store.state.showAddStudent;
    }
  }
};
</script>

<style>
* {
  margin: 0px;
  padding: 0;
  border: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
fieldset,
img {
  border: 0;
}
address,
caption,
cite,
code,
dfn,
em,
strong,
th,
var {
  font-style: normal;
  font-weight: normal;
}
ol,
ul {
  list-style: none;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: normal;
}
dl {
  margin-block-start: 0px;
  margin-block-end: 0px;
}
q:before,
q:after {
  content: "";
}
input,
button {
  border: none;
  font-family: "simhei";
}
button {
  background-color: transparent;
  cursor: pointer;
}
input:focus {
  box-shadow: rgba(0, 0, 0, 0.6) 0px 0px 3px;
  -moz-box-shadow: rgba(0, 0, 0, 0.6) 0px 0px 3px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.6) 0px 0px 3px;
}
input,
button:focus {
  outline: none;
}
input,
textarea,
select {
  border: 0; /* 方法1 */
  -webkit-appearance: none; /* 方法2 */
  border-radius: 0;
  outline: none;
}
/* 定位  浮动*/
.tl {
  text-align: left;
}
.tc {
  text-align: center;
}
.tr {
  text-align: right;
}
.bc {
  margin-left: auto;
  margin-right: auto;
}
.fl {
  float: left;
  display: block;
}
/* 可修复IE6中双倍边距bug */
.fr {
  float: right;
  display: block;
}
.cb {
  clear: both;
}
.cl {
  clear: left;
}
.cr {
  clear: right;
}
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.pr {
  position: relative;
}
.pa {
  position: absolute;
}
.zoom {
  zoom: 1;
}
.clear {
  *zoom: 1;
}
.clear:after {
  clear: both;
  content: ".";
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  zoom: 1;
}
.none {
  display: none;
}
.imgBox img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
a {
  color: inherit;
  text-decoration: none;
}
/*去除input的默认样式  number的箭头*/ /*在chrome下：*/
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
/*Firefox下：*/
input[type="number"] {
  -moz-appearance: textfield;
}
#app {
  width: 750px;
  margin: 0 auto;
  overflow: hidden;
  font-size: 16px;
  color: #333333;
  font-family: "Microsoft YaHei", "simhei";
}
.tower_wyh_hy {
  width: 100%;
  line-height: 30px;
  height: 30px;
  background-color: #f0f0f4;
}
.tower_wyh_hy span {
  display: block;
  width: 690px;
  margin: 0 auto;
  font-size: 18px;
}

.header {
  width: 100%;
  height: 150px;
  box-sizing: border-box;
  padding: 32px 30px 29px 30px;
  position: relative;
}
.header .logo a {
  height: 44px;
  float: left;
}
.header .logo a img {
  display: block;
  width: auto;
  height: 100%;
}
.header .logo p {
  float: left;
  margin-left: 13px;
  height: 44px;
  border-left: solid 1px #000;
  padding-left: 15px;
}
.header .logo p b {
  display: block;
  font-size: 21px;
  font-weight: bold;
  color: #333333;
  line-height: 1;
  margin-bottom: 7px;
}
.header .logo p span {
  display: block;
  font-size: 16px;
  color: #333333;
  line-height: 1;
}
.header .rxdh {
  font-style: italic;
  line-height: 1;
  font-size: 25px;
  color: #333333;
  letter-spacing: 1px;
  margin-top: 24px;
}
.header .rxdh i {
  color: #ec6a44;
  font-weight: bold;
  font-style: italic;
}
.header .fr {
  margin-top: 25px;
}
.header .navBtn {
  width: 44px;
  height: 34px;
}
.header .navBtn span {
  display: block;
  height: 5px;
  background-color: #000000;
  border-radius: 3px;
  float: right;
}
.header .navBtn .icon1,
.header .navBtn .icon3 {
  width: 27px;
}
.header .navBtn .icon2 {
  width: 44px;
  margin: 9px 0;
}
.header .nav {
  display: none;
  width: 280px;
  position: absolute;
  top: 150px;
  right: 30px;
  background-color: #fff;
  z-index: 99;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
}
.header .nav li a {
  display: block;
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  transition: all 0.4s;
  font-size: 26px;
}
.header .nav li > dl {
  display: none;
  transition: background-color 0.4s;
}
.header .nav li > dl > dd {
  position: relative;
}
.header .nav li > dl > dd > dl {
  position: absolute;
  right: 3rem;
  top: 0;
  width: 2.8rem;
  opacity: 0;
  pointer-events: none;
  transform: translateX(-10);
  transition: all 0.4s;
}
.header .nav li > dl > dd.on dl {
  opacity: 1;
  pointer-events: painted;
  transform: translateX(0);
}
.header .nav li > dl > dd > dl::after {
  content: "";
  display: block;
  width: 0;
  height: 0;
  border-top: solid 0.08rem transparent;
  border-left: solid 0.1rem #ca4d51;
  border-bottom: solid 0.08rem transparent;
  position: absolute;
  right: -0.1rem;
  top: 0.18rem;
}
.header .nav li > dl > dd > dl > dd {
  width: 2.8rem;
  height: 0.6rem;
  background-color: #ca4d51;
}

.header .nav li.on > a {
  background-color: #bf2b38;
  color: white;
}
.header .nav li.on > dl {
  background-color: #da414c;
  color: white;
}
.footer {
  width: 100%;
  overflow: hidden;
  padding: 25px 30px 15px 30px;
  margin-bottom: 98px;
  box-sizing: border-box;
}
.footer .fl {
  width: 400px;
}
.footer .fl img {
  display: block;
  height: 43px;
  margin-bottom: 19px;
}
.footer .fl p {
  font-size: 0px;
  line-height: 34px;
  color: #333333;
  text-align: justify;
}
.footer .fl p > * {
  font-size: 18px;
}
.footer .fl p span {
  display: block;
}
.footer .fr {
  padding-top: 92px;
}
.footer .fr dd {
  float: left;
  /* width: 98px; */
  margin-left: 15px;
}
.footer .fr dd img {
  display: block;
  width: 75px;
  height: 75px;
  border: solid 2px #fff;
}
.footer .fr dd span {
  display: block;
  font-size: 16px;
  line-height: 1;
  text-align: center;
  margin-top: 5px;
}
#bottomFC {
  width: 100%;
  height: 98px;
  background-color: #4a77f6;
  display: flex;
  position: fixed;
  left: 0px;
  bottom: 0px;
  z-index: 99;
}
#bottomFC > * {
  flex: 1;
  height: 98px;
  line-height: 98px;
  text-align: center;
  font-size: 0;
}
#bottomFC span {
  font-size: 26px;
  color: white;
  display: inline-block;
  position: relative;
  padding-left: 50px;
}
#bottomFC span::before {
  content: "";
  width: 30px;
  height: 30px;
  position: absolute;
  left: 0px;
  top: 34px;
}
#bottomFC .btn1 span::before {
  background: url(./assets/img/bottom_icon1.png) no-repeat;
  background-size: cover;
}
#bottomFC .btn2 span::before {
  background: url(./assets/img/bottom_icon2.png) no-repeat;
  background-size: cover;
}
#bottomFC .btn3 span::before {
  background: url(./assets/img/bottom_icon3.png) no-repeat;
  background-size: cover;
}
#bottomFC .btn2 {
  background-color: #f2a354;
}
#zxbm {
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.2);
  top: 0px;
  left: 0px;
  z-index: 9999;
}
#zxbm .zxbmBox {
  width: 580px;
  /* height: 550px; */
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 20px;
}
#zxbm .close-btn {
  width: 61px;
  height: 61px;
  cursor: pointer;
  border-radius: 32px;
  background-color: white;
  position: absolute;
  left: 50%;
  bottom: -91px;
  transform: translateX(-50%);
}
#zxbm .close-btn::before {
  content: "";
  width: 32px;
  height: 32px;
  background: url(./assets/img/Btn_close_b.png) center no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
#zxbm .fr {
  width: 690px;
  /* height: 550px; */
}
#zxbm .fl {
  width: 100%;
  box-sizing: border-box;
  padding: 0px 20px;
}
#zxbm .fl h3 {
  width: 210px;
  height: 31px;
  margin: 0 auto;
  padding-top: 20px;
}
#zxbm .fl dl {
  padding-top: 5px;
}
#zxbm .fl dd {
  width: 507px;
  height: 79px;
  line-height: 79px;
  margin: 0 auto;
  background-color: #f6f6f6;
  border-radius: 10px;
  margin-top: 30px;
}
#zxbm .fl dd input {
  float: right;
  width: 380px;
  height: 79px;
  font-size: 26px;
  line-height: 79px;
  background-color: #f6f6f6;
  box-sizing: border-box;
}
#zxbm input:focus {
  box-shadow: none;
}
#zxbm .fl dd label {
  display: block;
  float: left;
  width: 85px;
  font-size: 28px;
  color: #333;
  margin-left: 33px;
  position: relative;
  z-index: 1;
}
.mustInput::before {
  content: "*";
  height: 100%;
  line-height: 79px;
  color: #b0393d;
  position: absolute;
  left: -25px;
  top: 0px;
}
#zxbm .select {
  float: right;
  width: 380px;
  height: 79px;
  font-size: 26px;
  line-height: 79px;
  background-color: #f6f6f6;
  box-sizing: border-box;
  position: relative;
}
#zxbm .select ul {
  width: 507px;
  /* height: 240px; */
  height: 0px;
  position: absolute;
  top: 79px;
  right: 0px;
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: #f6f6f6;
  border-radius: 10px;
  z-index: 99;
  transition: all 0.4s;
}
#zxbm .select ul.selectActive {
  height: 240px;
}
#zxbm .select::after {
  content: "";
  width: 26px;
  height: 15px;
  background: url(./assets/img/select_icon.png) center no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 9px;
  top: 31px;
}
#zxbm .select h4 {
  width: 100%;
  height: 100%;
  font-size: 26px;
  color: #333333;
}
#zxbm .select ul li {
  width: 380px;
  height: 60px;
  line-height: 60px;
  float: right;
  font-size: 26px;
  color: #333333;
}
.addUser {
  width: 507px;
  height: 79px;
  background-image: linear-gradient(266deg, #1c77e8 0%, #4fa4fe 100%),
    linear-gradient(#eaeaea, #eaeaea);
  background-blend-mode: normal, normal;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: 47px;
  margin-bottom: 40px;
  text-align: center;
  line-height: 79px;
  font-size: 32px;
  color: white;
  cursor: pointer;
}
#loading {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999999;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 1;
  transition: opacity 0.4s;
}
#loading.on {
  opacity: 0;
  pointer-events: none;
}
#loading .sk-chase-dot:before {
  background-color: white;
}
#loading .sk-chase {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -20px;
  margin-top: -20px;
}
#T_imgShow {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: black;
  z-index: 99;
}
#T_imgShow img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
#T_imgShow .close {
  display: block;
  width: 20px;
  height: 20px;
  background-color: #fff;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 100;
  background-image: url(./assets/img/close.png);
  background-position: center;
  background-size: 16px 16px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue